/** @format */
import Link from 'next/link';

import styles from '@styles/common/Letter.module.scss';
import {charaters} from '@utils/charaters';

function Letters(props) {
	const {data, href, activeFilter, position, callBack, charater} = props;

	return (
		<div
			className={`${styles.letters} ${
				position === 'fixed' ? styles.fixed : styles.relative
			}`}
		>
			<div className={styles.desktopLetterSection}>
				{charaters.map(char => {
					if (char !== 'All' || (activeFilter && char === 'All'))
						return (
							<div
								id={`link-item-${char}`}
								className={styles.letter}
								key={char}
							>
								<div
									className={styles.char}
									onClick={() => (callBack ? callBack(char) : '')}
								>
									{!activeFilter ? (
										<span
											className={
												charater && charater === char ? styles.active : ''
											}
										>
											{char}
										</span>
									) : data[char] || char === 'All' ? (
										<Link
											href={`${href}${char}`} // onClick={() => (callBack ? callBack(char) : '')}
											className={
												charater && charater === char ? styles.active : ''
											}
										>
											{char}
										</Link>
									) : (
										<span className={styles.inactive}>{char}</span>
									)}
								</div>
							</div>
						);
				})}
			</div>
		</div>
	);
}

export default Letters;
